import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { ErrorHandlerService } from '../core/error-handler';
import { environment } from '../../environments/environment';

interface SettingsUserContext {
  userName?: string;
  userSettings: any;
}

@Injectable()
export class SettingsService {
  constructor(
    private http: HttpClient,
    private ehs: ErrorHandlerService
  ) {}

  public loadUserSettings(userName: string) {
    const url = `/api/user/settings/${userName}`;
    return this.http.get(environment.spotlightApiUrl + url).pipe(
      map((res: any) => this.deserializeFavoriteLocations(res.responseObject || {})),
      catchError((err) => this.ehs.handleError(err))
    );
  }

  public saveUserSettings(settings: any, user: SettingsUserContext) {
    let req = this.serializeFavoriteLocations({ ...user.userSettings, ...settings, username: user.userName });
    const url = `/api/user/settings/${user.userName}`;
    return this.http.post(environment.spotlightApiUrl + url, req).pipe(
      map((res: any) => this.deserializeFavoriteLocations(res.responseObject || [])),
      catchError((err) => this.ehs.handleError(err))
    );
  }

  // The API DTO still uses the field name "defaultLocation" (unchanged) and stores it as a
  // comma-separated string, not an array - keep that mapping contained here so the rest of
  // the app can work with a plain favoriteLocations: string[].
  private serializeFavoriteLocations(settings: any): any {
    if (!Array.isArray(settings?.favoriteLocations)) {
      return settings;
    }
    const { favoriteLocations, ...rest } = settings;
    return { ...rest, defaultLocation: favoriteLocations.join(',') };
  }

  private deserializeFavoriteLocations(settings: any): any {
    if (typeof settings?.defaultLocation !== 'string') {
      return settings;
    }
    const { defaultLocation, ...rest } = settings;
    const favoriteLocations = defaultLocation
      ? defaultLocation.split(',').map((locationNumber: string) => locationNumber.trim()).filter(Boolean)
      : [];
    return { ...rest, favoriteLocations };
  }
}
